import { useRef, useState } from 'react';

interface Props {
  onChange: (c: string) => any;
  className?: string;
}

export function SixDigitField(props: Props) {
  const [digits, setDigits] = useState(['', '', '', '', '', '']);
  const refs = [
    useRef<HTMLInputElement>(),
    useRef<HTMLInputElement>(),
    useRef<HTMLInputElement>(),
    useRef<HTMLInputElement>(),
    useRef<HTMLInputElement>(),
    useRef<HTMLInputElement>(),
  ];

  function setFocus(focus: number) {
    refs[focus]?.current?.focus();
  }

  function set(index: number, number: string) {
    const clone = [...digits];
    clone[index] = number;

    if (clone !== digits) {
      setDigits(clone);
      props.onChange(clone.join(''));
    }
  }

  function onKeyDown(e: React.KeyboardEvent<HTMLInputElement>, i: number) {
    let key = e.key;
    if (key === 'Backspace') {
      const target = e.target as HTMLInputElement;
      if (target && target.value === '') {
        setFocus(i - 1);
      }
    } else if (key === 'ArrowLeft') {
      setFocus(i - 1);
    } else if (key === 'ArrowRight') {
      setFocus(i + 1);
    }
  }
  function handleChange(e: React.ChangeEvent<HTMLInputElement>, i: number) {
    if (!e.target?.value?.match(/^[0-9]$/)) {
      e.target.value = '';
      set(i, '');
    } else {
      set(i, e.target.value);
      setFocus(i + 1);
    }
  }
  function onPaste(e: { clipboardData: any }, i: number) {
    try {
      const data = e?.clipboardData?.getData('Text');
      if (data) {
        const parsed = data.trim();
        if (parsed.match(/[0-9]{6}/)) {
          // @ts-ignore
          refs[0].current.value = parsed[0];
          // @ts-ignore
          refs[1].current.value = parsed[1];
          // @ts-ignore
          refs[2].current.value = parsed[2];
          // @ts-ignore
          refs[3].current.value = parsed[3];
          // @ts-ignore
          refs[4].current.value = parsed[4];
          // @ts-ignore
          refs[5].current.value = parsed[5];
          props.onChange(parsed);
        }
      }
    } catch (e) {}
  }

  let inputs = [];
  for (let i = 0; i < 6; i++) {
    inputs.push(
      <input
        // @ts-ignore
        ref={refs[i]}
        autoFocus={i === 0}
        className={props.className}
        key={i}
        type="text"
        data-testid={`six-digits-${i}`}
        inputMode="numeric"
        onKeyDown={(e) => onKeyDown(e, i)}
        onChange={(e) => handleChange(e, i)}
        onFocus={(e) => {
          e.target.select();
        }}
        maxLength={1}
        pattern="[0-9]*"
        autoComplete={i === 0 ? 'one-time-code' : ''}
        onPaste={(e) => onPaste(e, i)}
      />
    );
  }
  return <>{inputs}</>;
}

export default SixDigitField;
